import { Box, Flex } from '@chakra-ui/react';
import { Button, Text } from '@kula-ai/components';
import { AlertCircle } from '@kula-ai/icons-core';
import type { ErrorBlockProps } from './ErrorBlock.types';

export const ErrorBlock = ({ data, onRetry }: ErrorBlockProps) => {
  const showRetry = data.retryable && data.retryAction !== undefined;
  return (
    <Box
      role="alert"
      className="bg-error-100/10 border border-error-200 rounded-lg p-3"
    >
      <Flex align="flex-start" gap="8px" className="text-error-300">
        <Box flexShrink={0} mt="2px">
          <AlertCircle size={16} color="currentColor" />
        </Box>
        <Box flex="1">
          <Text variant="p" className="text-error-300">
            {data.message}
          </Text>
          {showRetry && (
            <Button
              size="sm"
              variant="quaternary"
              className="mt-2 text-error-300"
              onClick={() => onRetry?.(data.retryAction!)}
            >
              Retry
            </Button>
          )}
        </Box>
      </Flex>
    </Box>
  );
};
